<template>
  <div>
    <div class="card-toolbar-settings" v-if="getUseModalCart === false">
      <toolbar-settings :block="true" :small="false"></toolbar-settings>
    </div>

    <div class="card-toolbar-settings">
      <search-user></search-user>
    </div>
    <LiveMatchTracker
      v-if="
        !this.checkIsMobile() &&
        this.getLiveMode == 'detail' &&
        this.getEventsLiveDetail.length > 0 &&
        getUseModalCart === false
      "
    ></LiveMatchTracker>

    <BetInAcceptance></BetInAcceptance>
    <CartMarketView v-if="getGameConsole === 'marketview'"></CartMarketView>
    <Cart v-else></Cart>
    <GetBookedBet v-if="getUseModalCart === false"></GetBookedBet>
    <ImagesAds></ImagesAds>
  </div>
</template>

<script>
import Cart from '@/components/right_widgets/Cart'
import CartMarketView from './right_widgets/CartMarketView'
import LiveFieldWidget from '@/components/generic/LiveFieldWidget'
import GetBookedBet from '@/components/right_widgets/GetBookedBet'
import ImagesAds from './right_widgets/ImageAds'
import { mapGetters } from 'vuex'
import BetInAcceptance from '@/components/right_widgets/BetInAcceptance'
import ToolbarSettings from './generic/ToolbarSettings'
import SearchUser from './generic/SearchUser'
import { isMobileOnly } from 'mobile-device-detect'
import LoadingSkeleton from '@/components/generic/LoadingSkeleton'
import { checkIsMobileDevice } from '@/plugins/device-inspector'

const LiveMatchTracker = () => ({
  component: import('@/components/right_widgets/LiveMatchTracker'),
  loading: LoadingSkeleton,
  timeout: 200,
})

export default {
  name: 'Right',
  components: {
    BetInAcceptance,
    LoadingSkeleton,
    LiveMatchTracker,
    ImagesAds,
    GetBookedBet,
    LiveFieldWidget,
    Cart,
    CartMarketView,
    ToolbarSettings,
    SearchUser,
  },
  data: () => ({
    isMobileOnly: isMobileOnly,
  }),
  computed: {
    ...mapGetters({
      getGameConsole: 'settings/getGameConsole',
      getLiveMode: 'odds/getLiveMode',
      getEventsLiveDetail: 'odds/getEventsLiveDetail',
      getUseModalCart: 'uiConfig/useModalCart',
    }),
  },
  methods: {
    checkIsMobile() {
      return checkIsMobileDevice()
    },
  },
}
</script>
